import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

import FilterableOptionCards from 'components/common/OptionCards/FilterableOptionCards';
import InputError, { ERROR_PLACE } from 'components/InputsField/InputError';

import { useTransportDictionaries, toSelectedArray } from '../dictionaries';
import styles from './styles.module.scss';

const FIELD = 'transport_bodytype_ids';

const TypeStep = () => {
  const { t } = useTranslation();
  const { bodyTypes } = useTransportDictionaries();
  const { values, errors, touched, submitCount, setFieldValue, setFieldTouched } =
    useFormikContext<any>();

  const selected = toSelectedArray(values[FIELD]);

  const handleToggle = (value: string | number) => {
    const next = selected.some((item) => String(item) === String(value))
      ? selected.filter((item) => String(item) !== String(value))
      : [...selected, value];
    setFieldValue(FIELD, next);
    setFieldTouched(FIELD, true, false);
  };

  const showError = Boolean((touched[FIELD] || submitCount > 0) && errors[FIELD]);

  return (
    <div className={styles.step}>
      <p className={styles.stepTitle}>
        {t('transportFields.steps.type_prompt')}
        <i className={styles.required}>*</i>
      </p>
      <FilterableOptionCards
        options={bodyTypes}
        columns={3}
        value={selected}
        onChange={handleToggle}
      />
      {showError && <InputError message={errors[FIELD] as string} mode={ERROR_PLACE.static} />}
    </div>
  );
};

export default TypeStep;
